up.macro('[ngenic-confirm]', (element: HTMLElement) => {
    let dialogElement: HTMLElement;
    let suppressClickHandler: boolean = false;

    //const show = (event) => {
    //    if (suppressClickHandler)
    //        return;

    //    event.preventDefault();

    //    const content = up.element.attr(element, 'ngenic-confirm');
    //    const action = up.element.attr(element, 'ngenic-confirm-action');
    //    const buttonOkLabel = up.element.attr(element, 'ngenic-confirm-button-ok');
    //    const buttonCancelLabel = up.element.attr(element, 'ngenic-confirm-button-cancel');

    //    dialogElement = up.element.createFromHTML(`
    //        <div class="mdc-dialog">
    //            <div class="mdc-dialog__container">
    //                <div class="mdc-dialog__surface"
    //                    role="alertdialog"
    //                    aria-modal="true"
    //                    aria-describedby="my-dialog-content">
    //                    <div class="mdc-dialog__content" id="my-dialog-content">${content}</div>
    //                    <div class="mdc-dialog__actions">
    //                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="${action}">
    //                            <div class="mdc-button__ripple"></div>
    //                            <span class="mdc-button__label">${buttonOkLabel}</span>
    //                        </button>
    //                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="cancel">
    //                            <div class="mdc-button__ripple"></div>
    //                            <span class="mdc-button__label">${buttonCancelLabel}</span>
    //                        </button>
    //                    </div>
    //                </div>
    //            </div>
    //            <div class="mdc-dialog__scrim"></div>
    //        </div>    
    //    `);

    //    document.body.appendChild(dialogElement);

    //    dialogInstance = new dialog.MDCDialog(dialogElement);
    //    element['MDCSnackbar'] = dialogInstance;

    //    dialogInstance.listen('MDCDialog:closed', (customEvent: CustomEvent) => {
    //        dialogInstance.destroy();

    //        if (customEvent.detail.action === action) {
    //            suppressClickHandler = true;
    //            element.click();
    //            suppressClickHandler = false;
    //        }

    //        document.body.removeChild(dialogElement);
    //        dialogElement = null;
    //    });

    //    dialogInstance.open();
    //}

    //var cleanup = [
    //    up.on(element, 'click', show)
    //];

    //return () => {
    //    if (dialogInstance)
    //        dialogInstance.destroy();

    //    cleanup.forEach(fn => fn());

    //    if (dialogElement)
    //        document.body.removeChild(dialogElement);
    //};
});